'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTR_MAP = {
  phewas: 'fill',
  manhattan: 'stroke'
};

var HIGHLIGHT_MAP = {
  phewas: _theme2.default.point.highlightColor,
  manhattan: _theme2.default.line.highlightColor
};

var COLOR_MAP = {
  phewas: _theme2.default.point.color,
  manhattan: _theme2.default.line.color
};

var ID_MAP = {
  phewas: 'studyId',
  manhattan: 'indexVariantId'
};

function withTooltip(WrappedComponent, ListTooltip, tableColumns, type) {
  return function (_Component) {
    _inherits(_class2, _Component);

    function _class2() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class2);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        open: false,
        anchorData: null,
        anchorEl: null
      }, _this.handleMouseOver = function (data) {
        var anchorEl = _this.state.anchorEl;

        if (anchorEl) {
          anchorEl.setAttribute(ATTR_MAP[type], anchorEl.dataset.colour || COLOR_MAP[type]);
        }

        var loci = document.querySelector('.loci-' + data[ID_MAP[type]]);
        loci.setAttribute(ATTR_MAP[type], HIGHLIGHT_MAP[type]);

        _this.setState({
          open: true,
          anchorData: data,
          anchorEl: loci
        });
      }, _this.handleMouseLeave = function (event) {
        var anchorEl = _this.state.anchorEl;

        if (anchorEl) {
          anchorEl.setAttribute(ATTR_MAP[type], anchorEl.dataset.colour || COLOR_MAP[type]);
        }

        _this.setState({
          open: false,
          anchorData: null,
          anchorEl: null
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class2, [{
      key: 'render',
      value: function render() {
        var _state = this.state,
            anchorEl = _state.anchorEl,
            anchorData = _state.anchorData,
            open = _state.open;

        var dataList = anchorData ? tableColumns.map(function (_ref2) {
          var label = _ref2.label,
              id = _ref2.id,
              renderCell = _ref2.renderCell;
          return {
            label: label,
            value: renderCell ? renderCell(anchorData) : anchorData[id]
          };
        }) : [];
        return _react2.default.createElement(
          'div',
          { onMouseLeave: this.handleMouseLeave },
          _react2.default.createElement(WrappedComponent, _extends({
            handleMouseover: this.handleMouseOver
          }, this.props)),
          _react2.default.createElement(ListTooltip, { open: open, anchorEl: anchorEl, dataList: dataList })
        );
      }
    }]);

    return _class2;
  }(_react.Component);
}

exports.default = withTooltip;